import { toLower } from 'lodash';

export class QueryStatistics {
  keywords = new Set<string>();
  kpiNames = new Set<string>();
  // all in milllisec
  timeRange = {
    fromTime: '0',
    toTime: '0',
    timerange: '0'
  };
  // comes straight from queryStruct
  queryFilter: string;
  // comes from queryStruct.options.requestFor
  requestFor: string;

  private keywordsAtRisk = [
    'ip1', 'ip2', 'ip1_long1', 'ip1_long2', 'ip2_long1', 'ip2_long2',
    'user1', 'user2', 'user1_resourceid', 'user1resourceid', 'user2_resourceid', 'user2resourceid',
    'ip_dst', 'ip_src', 'user_resourceid_dst', 'user_resourceid_src',
    'port1', 'port2', 'mac1', 'mac2',
    'ip', 'port', 'user_resourceid', 'mac', 'ip_long1', 'ip_long2'
  ];
  private kpisAtRisk = [
    'voipcall_mos-audio-average-with-exploded-voipcallenrichedips',
    'voipcall_mos-audio-average-with-exploded-voipcallenrichedips-slow',
    'combinedflow_unique-users-count-total',
    'combinedflow_connection-count-by-siteresourceid' // because connection-count needs to know IP count
  ];

  registerKeywords(input: any[]) {
    if (input && input.length > 0) {
      for (const keyword of input) {
        this.keywords.add(toLower(keyword));
      }
    }
  }

  registerKpiName(name) {
    if (!name) {
      return;
    }
    this.kpiNames.add(name.toLowerCase());
  }


  usesKpiAtRisk() {
    for (const name of this.kpisAtRisk) {
      if (this.kpiNames.has(name)) {
        return true;
      }
    }
    return false;
  }

  usesKeywordsAtRisk() {
    for (const keyword of this.keywordsAtRisk) {
      if (this.keywords.has(keyword)) {
        return true;
      }
    }
    return false;
  }

  isLargerThan24Hours(start, end) {
    if (Number(Number(end) - Number(start)) > 24*60*60*1000) {
      return true; // exceeds 24 hours period
    }
    return false;
  }

  isOlderThan31day(start) {
    if ((Date.now() - Number(start)) > 31*24*60*60*1000) {
      return true;// query beginning is older than 31 days - db will revert itself to data models without certain columns
    }
    return false;
  }

  /**
   * Cases to consider:
   * a) only timerange (fromTime and toTime are empty)
   * b) only fromTime (timerange and toTime are empty)
   * c) fromTime and toTime (timerange is empty)
   * if calculated time period is larger than 24 hours - this must be reported.
   * Equally, if beginning of time period is older than 31 day ago - this again must be reported.
   */
  violatesTimeConstraint() {
    // case c)
    if (this.timeRange.fromTime && this.timeRange.toTime) {
      if (this.isLargerThan24Hours(this.timeRange.fromTime, this.timeRange.toTime)) {
        return true;
      }
      if (this.isOlderThan31day(this.timeRange.fromTime)) {
        return true;
      }
      return false;
    }
    // case b)
    if (this.timeRange.fromTime) {
      if (this.isLargerThan24Hours(this.timeRange.fromTime, Date.now())) {
        return true;
      }
      // no need to check whether older than 31 day.
      return false;
    }
    // case a)
    if (this.timeRange.timerange) {
      if (Number(this.timeRange.timerange) > 24*60*60*1000) {
        return true; // exceeds 24 hours period
      }
    }

    return false;
  }

  willResultInAnError(): boolean {
    if (this.queryFilter || this.requestFor) {
      // if value is set, then most likely it will use relational database on backend side (or some other special case,
      // like 'requestFor' = 'FlowForensics' to request prolonged periods of data),
      // hence it is fine to query with sensitive keywords or longer time spans.
      return false;
    }

    if ((this.usesKeywordsAtRisk() || this.usesKpiAtRisk()) && this.violatesTimeConstraint()) {
      return true;
    }
    return false;
  }
}
